export default "__VITE_ASSET__DYuUWMiM__"